import React from "react";
export const BuyersEmailColumnFormatter = (cellContent, row, rowIndex) => {
  const { buyer_email } = row || {};
  return (
    <>
      <span className="text-dark-75 d-block"></span>
      <> {buyer_email} </>
    </>
  );
};
